import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import ListRow from './ListRow';
import ListRowContainer from './ListRowContainer';
import type { ListRowProps } from './ListRow';

/**
 * ListRowLoading is a ListRow with some loading content.
 * Currently just renders a content loader in the shape of
 * what a ListRowDetail might look like, but we can build on this
 * in the future if we want.
 */
const ListRowLoading: VoidFunctionComponent<ListRowProps> = (props) => (
  <ListRowContainer>
    {/* eslint-disable-next-line react/jsx-props-no-spreading -- It's fine */}
    <ListRow {...props}>
      <ContentLoader width="100%" height="46px">
        <rect x="0" y="0" rx="3" ry="3" width="25%" height="19" />
        <rect x="0" y="32" rx="3" ry="3" width="15%" height="12" />
        <rect x="17%" y="32" rx="3" ry="3" width="15%" height="12" />
        <rect x="34%" y="32" rx="3" ry="3" width="15%" height="12" />
      </ContentLoader>
    </ListRow>
  </ListRowContainer>
);

export default ListRowLoading;
